var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['base-button', _vm.primaryColor],on:{"click":_vm.onClick}},[_vm._t("default"),(_vm.showIcon)?_c('icon-arrow',{staticClass:"icon-arrow"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }